import browser from '@openclassrooms/utils/browser';

export default function handleUniversalSearch() {
  const searchContainer = browser.document.getElementById('mainSearch');

  if (searchContainer && searchContainer.hasChildNodes()) {
    browser.document.body.style.display = 'none';
    browser.window.location.reload();
  }
}
